// ============================================
// GREEK TRANSLATIONS
// ============================================
// Edit all text content for your portfolio here

export const el = {
  // ==================== PERSONAL INFO ====================
  personal: {
    firstName: "Παναγιώτης",
    lastName: "Μπέκος",
    fullName: "Παναγιώτης Μπέκος",
    profession: "Ξυλογλύπτης",
    bio: `Η στάση μου απέναντι σ' αυτή την παράδοση είναι στάση μελέτης και μαθητείας πάνω στα έργα μεγάλων ξυλογλυπτών,
    που προδίδουν γνώση, πείρα, ευαισθησία, υψηλή τεχνική, και που πολλές φορές είναι η αποτύπωση της εμπειρίας του εκκλησιαστικού 
    βιώματος, πάνω στο άψυχο υλικό, όσο αυτό είναι δυνατό. Η συνεργασία μου, με έμπειρους τεχνίτες, στοχεύει στην επιτυχή 
    συνέχιση της ξυλογλυπτικής τέχνης. Συνοδοιπόρος αυτής της προσπάθειας ο αδερφός μου Θεόφιλος, θεολόγος και ιεροψάλτης. 
    Ελπίζω με τη χάρη του Θεού σε μελλοντική προσωπική επαφή και συνεργασία.`,
  },

  // ==================== CONTACT INFO ====================
  contact: {
    email: "p9bekos@gmail.com",
    phone: "+30 6936881488",
    address: {
      street: "Αριστοτέλους 23",
      city: "Ηλιούπολη",
      postalCode: "16343",
      country: "Ελλάδα",
    },
    social: {
      facebook: "https://www.facebook.com/your-page",
      instagram: "https://www.instagram.com/your-account",
    },
  },

  // ==================== HEADER ====================
  header: {
    woodcarverName: "Παναγιωτης",
    woodcarverSurname: "Μπεκος",
    woodcarverSpeciality: "Ξυλογλυπτης",
    main: "Αρχικη",
    gallery: "Δημιουργιες",
    about: "Το Εργαστηρι",
    contact: "Επικοινωνια"
  },

  // ==================== FOOTER ====================
  footer: {
    woodcarverFullName: "Παναγιώτης Μπέκος",
    description: "Ξυλογλύπτης",
    main: "Αρχική",
    gallery: "Δημιουργίες",
    about: "Το Εργαστήρι",
    contact: "Επικοινωνία"
  },

  // ==================== MAIN PAGE ====================
  main: {
    heroTitle: "Ξυλογλυπτικη",
    heroSubtitle: "Η τέχνη που χαράσει ιστορίες στην καρδιά του ξύλου",
    gallerySubtitle: "ΚΑΤΗΓΟΡΙΕΣ",
    galleryTitle: "Δημιουργίες",
    textToGallery: "Ανακαλύψτε όλες τις δημιουργίες μου",
    buttonToGallery: "Δείτε τη συλλογή",
    contactSubtitle: "ΕΠΙΚΟΙΝΩΝΙΑ",
    contactTitle: "Επικοινωνήστε μαζί μου",
    footerImageText: "\"...καὶ ἔστω ἡ λαμπρότης Κυρίου τοῦ Θεοῦ ἡμῶν ἐφ᾿ ἡμᾶς, καὶ τὰ ἔργα τῶν χειρῶν ἡμῶν κατεύθυνον ἐφ᾿ ἡμᾶς καὶ τὸ ἔργον τῶν χειρῶν ἡμῶν κατεύθυνον\" - Ψαλμός 89:17"
  },

  // ==================== GALLERY PAGE ====================
  gallery: {
    heroTitle: "Ξυλογλυπτικη Τεχνη",
    heroSubtitle: "Ξυλόγλυπτα έργα τέχνης φτιαγμένα με μεράκι και αγάπη για την παράδοση",
    title: "Δημιουργίες",
    subtitle: "ΚΑΤΗΓΟΡΙΕΣ",
    category: "ΚΑΤΗΓΟΡΙΑ",
    footerImageText: "\"... ὃ ἐὰν ποιῆτε, ἐκ ψυχῆς ἐργάζεσθε ὡς τῷ Κυρίῳ καὶ οὐκ ἀνθρώποις\" - Πρὸς Κολοσσαεῖς 3:23",
    return: "← Επιστροφή στις κατηγορίες",
    notAvailable: "Αυτή η κατηγορία δεν είναι διαθέσιμη ακόμα",
  },

  // ==================== ABOUT PAGE ====================
  about: {
    heroTitle: "Εργαστηρι Ξυλογλυπτικης",
    heroSubtitle: "Ο χώρος όπου η ξυλογλυπτική τέχνη ζωντανεύει",
    title: "Το Εργαστήρι μας",
    subtitle: "ΙΣΤΟΡΙΑ",
    aboutMeTitle: "Σχετικά με μένα",  // eslint-disable-next-line
    aboutMeText: "Η στάση μου απέναντι σ' αυτή την παράδοση είναι στάση μελέτης και μαθητείας πάνω στα έργα μεγάλων ξυλογλυπτών ,\
                που προδίδουν γνώση, πείρα, ευαισθησία, υψηλή τεχνική, και που πολλές φορές είναι η αποτύπωση της εμπειρίας του εκκλησιαστικού \
                    βιώματος, πάνω στο άψυχο υλικό, όσο αυτό είναι δυνατό.",
    woodcarverFullName: "Παναγιώτης Μπέκος",
    woodcarverSpeciality: "Ξυλογλύπτης",
    footerImageText: "\"... αὐτοῦ γάρ ἐσμέν ποίημα, κτισθέντες ἐν Χριστῷ Ἰησοῦ ἐπὶ ἔργοις ἀγαθοῖς\" - προς Ἐφεσίους 2:10"
  },

  // ==================== CONTACT PAGE ====================
  contactPage: {
    heroTitle: "Επικοινωνια",
    heroSubtitle: "Επικοινωνήστε μαζί μου για περισσότερες πληροφορίες",
    title: "Επικοινωνήστε μαζί μου",
    subtitle: "ΕΠΙΚΟΙΝΩΝΙΑ",
    contactInfoTitle: "Στοιχεία Επικοινωνίας",
    phoneTitle: "ΤΗΛΕΦΩΝΟ",
    addressTitle: "ΔΙΕΥΘΥΝΣΗ",
    followMe: "ΑΚΟΛΟΥΘΗΣΤΕ ΜΕ",
    quickMessageTitle: "Γρήγορο Μήνυμα",
    quickMessageText: "Στείλτε μου ένα σύντομο μήνυμα και θα επικοινωνήσω μαζί σας σύντομα",
    nameTitle: "Όνομα",
    namePlaceholder: "Το όνομά σας",
    messageTitle: "Μήνυμα",
    messagePlaceholder: "Γράψτε το μηνυμά σας...",
    messageButton: "Αποστολή μηνύματος",
    messageSending: "Αποστολή...",
    messageSent: "Στάλθηκε!",
    messageSuccess: "Ευχαριστώ! Θα επικοινωνήσω σύντομα.",
    footerImageText: "\"... καὶ ἴδε ἐπὶ τοὺς δούλους σου καὶ ἐπὶ τὰ ἔργα σου καὶ ὁδήγησον τοὺς υἱοὺς αὐτῶν\" - Ψαλμός 89:16"
  },

  // ==================== CATEGORIES ====================
  categories: {
    main: "Αρχική",
    gallery: "Δημιουργίες",
    about: "Το Εργαστήρι",
    contact: "Επικοινωνία",
    agies_trapezes: "Αγίες Τράπεζες",
    amvones: "Άμβωνες",
    analogia: "Αναλόγια",
    artoforia: "Αρτοφόρια",
    despotikoi_thronoi: "Δεσποτικοί Θρόνοι",
    diafora: "Διάφορα",
    diskelia:"Δισκέλια",
    epipla:"Έπιπλα",
    epitafioi:"Επιτάφιοι",
    filoptoha:"Φιλόπτωχα",
    kornizes:"Κορνίζες",
    lipsanothikes:"Λειψανοθήκες",
    kirothikes:"Κηροθήκες",
    polithrones:"Πολυθρόνες",
    portes:"Πόρτες",
    proskinitaria:"Προσκυνητάρια",
    prothikes:"Προθήκες",
    stasidia_karekles:"Στασίδια - Καρέκλες",
    stavroi:"Σταυροί",
    stefanothikes:"Στεφανοθήκες",
    templa:"Εικονοστάσια",
    trapezia: "Τραπέζια",
    vimothira: "Βημόθυρα",
  },

  categoriesNoTones: {
      main: "Αρχικη",
      gallery: "Δημιουργιες",
      about: "Το Εργαστηρι",
      contact: "Επικοινωνια",
      agies_trapezes: "Αγιες Τραπεζες",
      amvones: "Αμβωνες",
      analogia: "Αναλογια",
      artoforia: "Αρτοφορια",
      despotikoi_thronoi: "Δεσποτικοι Θρονοι",
      diafora: "Διαφορα",
      diskelia:"Δισκελια",
      epipla:"Επιπλα",
      epitafioi:"Επιταφιοι",
      filoptoha:"Φιλοπτωχα",
      kornizes:"Κορνιζες",
      lipsanothikes:"Λειψανοθηκες",
      kirothikes:"Κηροθηκες",
      polithrones:"Πολυθρονες",
      portes:"Πορτες",
      proskinitaria:"Προσκυνηταρια",
      prothikes:"Προθηκες",
      stasidia_karekles:"Στασιδια - Καρεκλες",
      stavroi:"Σταυροι",
      stefanothikes:"Στεφανοθηκες",
      templa:"Εικονοστασια",
      trapezia: "Τραπεζια",
      vimothira: "Βημοθυρα",
  },

  // ==================== MESSAGES ====================
  messages: {
    emailCopied: "Το Email αντιγράφηκε!",
    phoneCopied: "Το τηλέφωνο αντιγράφηκε!",
    nameRequired: "Το όνομα είναι υποχρεωτικό.",
    emailRequired: "Το email είναι υποχρεωτικό.",
    nameInvalid: "Το όνομα περιέχει μη έγκυρους χαρακτήρες.",
    emailInvalid: "Μη έγκυρο email.",
    messageRequired: "Το μήνυμα είναι υποχρεωτικό.",
    sendFailed: "Αποτυχία αποστολής. Παρακαλώ δοκιμάστε ξανά.",
  }
};